import type { IComment } from "../../../../../types/comment";

export const handleExport = (format: "csv" | "pdf", comment: IComment) => {
  const filename = `pending-comments-${comment.id}`;
  const commentsForExport = [comment];

  exportToCSV(commentsForExport, filename);
};

const exportToCSV = (comments: IComment[], filename: string) => {
  const headers = ["Author", "Comment", "Timestamp", "Source"];
  const csvContent = [
    headers.join(","),
    ...comments.map((comment) =>
      [
        `"${comment.author}"`,
        `"${comment.content.replace(/"/g, '""')}"`,
        `"${comment.timestamp}"`,
        `"${comment.source || "Pending"}"`,
      ].join(",")
    ),
  ].join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);
  link.setAttribute("href", url);
  link.setAttribute("download", filename);
  link.style.visibility = "hidden";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
